import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Dictionary from './Dictionary';
import './Navbar.css';

function Navbar() {
  const location = useLocation();
  const [showMore, setShowMore] = useState(false);
  const [showDictionary, setShowDictionary] = useState(false);

  // Get page title based on route
  const getPageTitle = () => {
    if (location.pathname.startsWith('/reports/')) return 'Report';
    switch (location.pathname) {
      case '/dashboard': return 'Dashboard';
      case '/reports': return 'Reports';
      case '/portfolio': return 'Portfolio';
      case '/valuation': return 'Valuation';
      case '/watchlist': return 'Watchlist';
      case '/transactions': return 'Transactions';
      case '/dividends': return 'Dividends';
      case '/screener': return 'Screener';
      case '/news': return 'News';
      case '/strategy': return 'Strategy';
      case '/daily': return 'Morning Desk';
      case '/chat': return 'Analyst Chat';
      case '/settings': return 'Settings';
      default: return 'Dashboard';
    }
  };

  return (
    <>
      {/* Top header for mobile */}
      <header className="mobile-header">
        <div className="mobile-header-content">
          <span className="brand-icon">$</span>
          <span className="page-title">{getPageTitle()}</span>
          <button
            className="mobile-dictionary-btn"
            onClick={() => setShowDictionary(true)}
            title="Finance Dictionary"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
            </svg>
          </button>
        </div>
      </header>

      {/* Desktop navbar */}
      <nav className="navbar desktop-nav">
        <div className="navbar-content container">
          <div className="navbar-brand">
            <span className="brand-icon">$</span>
            <span className="brand-text">Portfolio Report</span>
          </div>
          <div className="navbar-links">
            <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>
              Dashboard
            </NavLink>
            <NavLink to="/portfolio" className={({ isActive }) => isActive ? 'active' : ''}>
              Portfolio
            </NavLink>
            <NavLink to="/valuation" className={({ isActive }) => isActive ? 'active' : ''}>
              Valuation
            </NavLink>
            <NavLink to="/watchlist" className={({ isActive }) => isActive ? 'active' : ''}>
              Watchlist
            </NavLink>
            <NavLink to="/transactions" className={({ isActive }) => isActive ? 'active' : ''}>
              Transactions
            </NavLink>
            <NavLink to="/dividends" className={({ isActive }) => isActive ? 'active' : ''}>
              Dividends
            </NavLink>
            <NavLink to="/screener" className={({ isActive }) => isActive ? 'active' : ''}>
              Screener
            </NavLink>
            <NavLink to="/reports" className={({ isActive }) => isActive ? 'active' : ''}>
              Reports
            </NavLink>
            <NavLink to="/news" className={({ isActive }) => isActive ? 'active' : ''}>
              News
            </NavLink>
            <NavLink to="/strategy" className={({ isActive }) => isActive ? 'active' : ''}>
              Strategy
            </NavLink>
            <NavLink to="/daily" className={({ isActive }) => isActive ? 'active' : ''}>
              Daily
            </NavLink>
            <NavLink to="/chat" className={({ isActive }) => isActive ? 'active' : ''}>
              Chat
            </NavLink>
            <NavLink to="/settings" className={({ isActive }) => isActive ? 'active' : ''}>
              Settings
            </NavLink>
            <button
              className="navbar-dictionary-btn"
              onClick={() => setShowDictionary(true)}
              title="Finance Dictionary"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Bottom navigation for mobile */}
      <nav className="bottom-nav">
        <NavLink to="/dashboard" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
          </svg>
          <span>Dashboard</span>
        </NavLink>
        <NavLink to="/portfolio" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/>
          </svg>
          <span>Portfolio</span>
        </NavLink>
        <NavLink to="/watchlist" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
          </svg>
          <span>Watch</span>
        </NavLink>
        <NavLink to="/news" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
          </svg>
          <span>News</span>
        </NavLink>
        <button
          className={`bottom-nav-item ${showMore ? 'active' : ''}`}
          onClick={() => setShowMore(!showMore)}
        >
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
          </svg>
          <span>More</span>
        </button>
      </nav>

      {/* More menu overlay */}
      {showMore && (
        <div className="more-menu-overlay" onClick={() => setShowMore(false)}>
          <div className="more-menu" onClick={(e) => e.stopPropagation()}>
            <div className="more-menu-header">
              <span>More</span>
              <button className="more-menu-close" onClick={() => setShowMore(false)}>×</button>
            </div>
            <div className="more-menu-grid">
              <NavLink to="/valuation" className="more-menu-item" onClick={() => setShowMore(false)}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
                </svg>
                <span>Valuation</span>
              </NavLink>
              <NavLink to="/dividends" className="more-menu-item" onClick={() => setShowMore(false)}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                </svg>
                <span>Dividends</span>
              </NavLink>
              <NavLink to="/screener" className="more-menu-item" onClick={() => setShowMore(false)}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                </svg>
                <span>Screener</span>
              </NavLink>
              <NavLink to="/transactions" className="more-menu-item" onClick={() => setShowMore(false)}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"/>
                </svg>
                <span>Transactions</span>
              </NavLink>
              <NavLink to="/reports" className="more-menu-item" onClick={() => setShowMore(false)}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/>
                </svg>
                <span>Reports</span>
              </NavLink>
              <NavLink to="/strategy" className="more-menu-item" onClick={() => setShowMore(false)}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2zm0 3.8l4.58 12.2H7.42L12 5.8z"/>
                </svg>
                <span>Strategy</span>
              </NavLink>
              <NavLink to="/daily" className="more-menu-item" onClick={() => setShowMore(false)}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z"/>
                </svg>
                <span>Daily</span>
              </NavLink>
              <NavLink to="/chat" className="more-menu-item" onClick={() => setShowMore(false)}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
                </svg>
                <span>Chat</span>
              </NavLink>
              <NavLink to="/settings" className="more-menu-item" onClick={() => setShowMore(false)}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M19.14 12.94c.04-.31.06-.63.06-.94 0-.31-.02-.63-.06-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>
                </svg>
                <span>Settings</span>
              </NavLink>
              <button className="more-menu-item" onClick={() => { setShowMore(false); setShowDictionary(true); }}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
                </svg>
                <span>Dictionary</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Dictionary Modal */}
      <Dictionary isOpen={showDictionary} onClose={() => setShowDictionary(false)} />
    </>
  );
}

export default Navbar;
